export class DocumentDbClusterParameterGroup {
    'name';
    'family';
    'description';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "family",
            "baseName": "family",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DocumentDbClusterParameterGroup.attributeTypeMap;
    }
    constructor() {
    }
}
